var map = {
	"./filetype1.png": 79352,
	"./filetype2.png": 47981,
	"./filetype3.png": 16347,
	"./filetype4.png": 73116,
	"./filetype5.png": 86074,
	"./filetype6.png": 68173,
	"./filetype7.png": 24534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31763;